import { useState } from "react";
import { X, Heart } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const PRESETS = [3, 5, 10, 25];

export default function DonateModal({ work, onClose }) {
  const [amount, setAmount] = useState(5);
  const [custom, setCustom] = useState("");
  const [loading, setLoading] = useState(false);

  const finalAmount = custom ? parseFloat(custom) : amount;

  const submit = async () => {
    if (!finalAmount || finalAmount < 1) {
      toast.error("Minimum tip is $1.00");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        work_id: work.id,
        kind: "donation",
        amount_cents: Math.round(finalAmount * 100),
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiError(e));
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4" onClick={onClose} data-testid="donate-modal">
      <div
        className="relative w-full max-w-md bg-[#161412] border border-[rgba(217,180,114,0.25)] rounded-sm p-6 sm:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose} className="absolute top-4 right-4 text-[#6E675E] hover:text-[#F7F3EC]" data-testid="donate-modal-close">
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-2 mb-2">
          <Heart className="w-4 h-4 text-[#8C3A34]" />
          <div className="font-mono-brass text-xs uppercase tracking-widest text-[#8C3A34]">Anonymous Tip</div>
        </div>
        <h3 className="font-serif-display text-2xl text-[#F7F3EC] leading-tight mb-1">Support {work.author_pseudonym}</h3>
        <p className="text-sm text-[#A8A095] mb-6 font-serif-body italic">"{work.title}"</p>

        <div className="grid grid-cols-4 gap-2 mb-4">
          {PRESETS.map((v) => (
            <button
              key={v}
              onClick={() => { setAmount(v); setCustom(""); }}
              className={`py-3 rounded-sm font-mono-brass text-sm transition-colors duration-200 border ${
                !custom && amount === v
                  ? "bg-[rgba(140,58,52,0.35)] border-[#8C3A34] text-[#F7F3EC]"
                  : "bg-transparent border-[rgba(217,180,114,0.15)] text-[#A8A095] hover:border-[rgba(217,180,114,0.35)]"
              }`}
              data-testid={`donate-preset-${v}`}
            >
              ${v}
            </button>
          ))}
        </div>

        <div className="mb-6">
          <label className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass block mb-1.5">Custom amount (USD)</label>
          <input
            type="number"
            min="1"
            step="1"
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            placeholder="Enter your own"
            className="w-full bg-[#0D0C0A] border border-[rgba(217,180,114,0.15)] focus:border-[#D9B472] outline-none rounded-sm px-4 py-3 text-[#F7F3EC] font-mono-brass"
            data-testid="donate-custom-amount"
          />
        </div>

        <button
          onClick={submit}
          disabled={loading}
          className="btn-buy w-full rounded-sm py-3.5 font-mono-brass text-xs uppercase tracking-widest font-semibold disabled:opacity-60"
          data-testid="donate-submit"
        >
          {loading ? "Redirecting to Stripe…" : `Send $${finalAmount || 0} tip`}
        </button>
        <p className="text-[10px] text-[#6E675E] text-center mt-3 font-mono-brass">Stripe · Test mode · Card 4242 4242 4242 4242</p>
      </div>
    </div>
  );
}
